import Config from 'config/settings';
import webglHome from 'config/webgl-home';
import { device } from 'utils/device';

export default {
	showGuides: false,
	noOverlapSize: 1200,
	zones: [
		{
			name: 'home',
			width: 0.25,

			ui: {
				tolerence: 0.02,
				relX: 0.5,
				relY: 0.5
			},

			//
			regions: [
				{ id: 'Home', type: 'progress', range: { min: 0.0, max: 0.14 } },
				{ id: 'HomeLogoArea', type: 'rectangle', rect: { x2: 0.05, x: 0, w2: 0.1, w: 0.2, y: 0.4, h: 0.2 } }
			],

			//Content zone:
			//Designed sizes:
			content: {
				relX: 0.5, //Position relative to 'width' of the zone. I.e if x=0 and width=0.25 then centre will be 0.125
				relY: 0.5,
				baseHeight: 1009,
				minWidth: 500,
				baseWidth: 1000,
				maxWidth: 1000
			}
		},

		{
			name: 'screens',
			width: 0.25,
			shift: 0.1,
			ui: {
				tolerence: 0.02,
				relX: 0.5,
				relY: 0.5
			},

			regions: [
				{ id: 'Screens', type: 'progress', range: { min: 0.3, max: 0.5 } },
				{ id: 'SpacesTransition', type: 'progress', range: { min: 2, max: 2 } }
			],
			content: {
				relX: 0.455, //Position relative to 'width' of the zone. I.e if x=0 and width=0.25 then centre will be 0.125,
				relXMobile: 0.5, //Position relative to 'width' of the zone. I.e if x=0 and width=0.25 then centre will be 0.125
				xShift: -0.002, //Shift along content area when width < than say 1800px. This will allow left bias layouts like screens to be
				relY: 0.5,
				baseHeight: 1009,
				baseWidth: 900,
				minWidth: 900,
				maxWidth: 900,
				noOvelapWidthRatio: 0.95,
				mobileRelY: 0.46,
				mobileScaleBump: 1.5,
				mobileMaxHeightRatio: 0.9 //DO not allow cotent area to get larger than this in terms of overall screen height
			}
		},

		{
			name: 'spaces',
			width: 0.25,

			ui: {
				tolerence: 0.02,
				relX: 0.5,
				relY: 0.5
			},

			regions: [
				{ id: 'Spaces', type: 'progress', range: { min: 0.6, max: 0.8 } },
				{ id: 'SpacesBoxArea', type: 'rectangle', rect: { x: 0.55433, y: 0.1, w: 0.09, h: 0.2 } }
			],
			content: {
				//Sizes all as designed not real exact/sizes
				relX: 0.5, //Position relative to 'width' of the zone. I.e if x=0 and width=0.25 then centre will be 0.125
				relY: 0.5,
				baseHeight: 1009,
				minWidth: 600,
				widthRatioMobile: 0.8,
				noOvelapWidthRatio: 0.86,
				mobileRelY: 0.44,
				baseWidth: 600,
				maxWidth: 600
			}
		},

		{
			name: 'systems',
			width: 0.25,

			ui: {
				tolerence: 0.02,
				relX: 0.5,
				relY: 0.5
			},

			regions: [{ id: 'Systems', type: 'progress', range: { min: 0.8, max: 1 } }],
			content: {
				relX: 0.5, //Position relative to 'width' of the zone. I.e if x=0 and width=0.25 then centre will be 0.125
				relY: 0.5,
				baseHeight: 1009,
				minWidth: 600,
				baseWidth: 750,
				maxWidth: 1000,
				mobileRelY: 0.38
			}
		}
	],

	order: {
		home: 0,
		screens: 1,
		spaces: 2,
		systems: 3
	},

	xCache: {
		home: { min: null, max: null, timelinePoint: null },
		screens: { min: null, max: null, timelinePoint: null },
		spaces: { min: null, max: null, timelinePoint: null },
		systems: { min: null, max: null, timelinePoint: null }
	},

	uiXCache: {
		home: { min: null, max: null },
		screens: { min: null, max: null },
		spaces: { min: null, max: null },
		systems: { min: null, max: null }
	},

	createCaches() {
		let x = 0;

		let innerShare = 1 / (this.zones.length - 1);
		let i = 0;

		for (var zoneName in this.order) {
			let order = this.order[zoneName];
			let zone = this.getZone(zoneName);

			let x2 = x + zone.width;
			let timelinePoint = 0;
			let parallaxCenter = 0;

			//On 1st + last then the progress needs to be at 0% or 100% to be in place
			//Others are in the middle of their minX and the width
			if (order === 0) {
				timelinePoint = 0;
				parallaxCenter = 0;
			} else if (order >= this.zones.length - 1) {
				timelinePoint = 1;
				parallaxCenter = 1;
			} else {
				timelinePoint = x + zone.width / 2;
				parallaxCenter = innerShare * i;
			}

			this.xCache[zoneName] = {
				min: x,
				max: x2,
				timelinePoint: timelinePoint,
				parallaxCenter: parallaxCenter
			};

			//UI only shows after snap is more if less complete:
			//On 1st + last then the progress needs to be at approx 0% or 100%
			//On 2nd + 3rd then the propgress needs to be at approx
			this.uiXCache[zoneName] = {
				min: Math.max(0, this.xCache[zoneName].timelinePoint - zone.ui.tolerence),
				max: Math.min(1, this.xCache[zoneName].timelinePoint + zone.ui.tolerence)
			};

			//Increase x so next zone starts at the width
			x += zone.width;
			i++;
		}
	},

	getZone(zone) {
		return this.zones[this.order[zone]];
	},

	inZone(zoneName, progress) {
		return progress >= this.xCache[zoneName].min && progress <= this.xCache[zoneName].max;
	},

	showUI(zoneName, progress) {
		return progress >= this.uiXCache[zoneName].min && progress <= this.uiXCache[zoneName].max;
	},

	computedHomeZoneConfig() {
		//Generate the config that HomeTimeline uses for setting the content zones
		//These are the areas that elements sync to on timeline
		//This is now based on width + relX of content area
		//Will out put in form:

		/* {
            //screens: {cx: 0.16666, cy: 0.5, baseHeight: 1009, baseWidth: 750,  minWidth: 600, maxWidth: 1000  },
            //home: {cx: 0.5, cy:0.5, baseHeight: 1009, minWidth: 600, baseWidth: 750, maxWidth: 1000  },
            home: {cx: 0.125, cy:0.5, baseHeight: 1009, minWidth: 600, baseWidth: 750, maxWidth: 1000  },
            screens: {cx: 0.375, cy: 0.5, baseHeight: 1009, baseWidth: 750,  minWidth: 600, maxWidth: 1000  },
            //spaces: {cxx: 0.8333,  cx: 0.833333, cy:0.5, baseHeight: 1009, minWidth: 600, baseWidth: 750, maxWidth: 1000  }
            spaces: {cxx: 0.8333,  cx: 0.625, cy:0.5, baseHeight: 1009, minWidth: 600, baseWidth: 750, maxWidth: 1000  },
            systems: {cx: 0.875, cy: 0.5, baseHeight: 1009, baseWidth: 750,  minWidth: 600, maxWidth: 1000   }
        }; */

		let x = 0;
		let x2, zone;
		let config = {};

		for (var zoneName in this.order) {
			zone = this.getZone(zoneName);
			x2 = x + zone.width;

			config[zoneName] = zone.content;

			//Set the center of the content area to abs position on timeline:
			let relX = zone.content.relX;
			if (zone.content.relXMobile && device.innerWidth < Config.getCurrentMobileSwitch()) {
				relX = zone.content.relXMobile;
			}

			config[zoneName].cx = x + (x2 - x) * relX;
			config[zoneName].cy = zone.content.relY;
			config[zoneName].cyNoOverlap = zone.content.mobileRelY || zone.content.relY;

			x += zone.width;
		}

		return config;
	},

	computedHomeCssConfig() {
		let x = 0;
		let x2, zone;
		let config: { [zone: string]: { relX: number } } = {};

		for (var zoneName in this.order) {
			zone = this.getZone(zoneName);
			x2 = x + zone.width;

			config[zoneName] = {
				relX: x + (x2 - x) * zone.ui.relX
			};

			x += zone.width;
		}

		return config;
	},

	/**
	 * Will check the particles that should be active in a scene based on progress
	 * When range is small it means that will need to more or less stopped near snap point to show
	 * @param sceneProgress
	 * @returns
	 */
	getParticleSceneFromProgress(sceneProgress: number): string {
		//Band thresholds live in config/webgl-home (sceneBands) so other webgl types can share them:
		const bands = webglHome.sceneBands;
		if (sceneProgress < bands.iconMax) return 'icon';
		else if (sceneProgress >= bands.screens.min && sceneProgress <= bands.screens.max) return 'screens';
		else if (sceneProgress >= bands.spaces.min && sceneProgress <= bands.spaces.max) return 'spaces';
		else if (sceneProgress > bands.systemsMin) return 'systems';

		return null;
	},

	//Each zone has a progress between -1 to 1
	//0 is when in middle
	//Index 0 only works from 0 to +1
	//Last index only works -1 to 0
	getZoneParallaxProgress(progress): { [zone: string]: { abs: number; rel: number } } {
		let range: number;
		let abs: number;
		let rel: number;
		//any-valued: the loop briefly stores a number in each slot before replacing
		//it with the { abs, rel } record:
		let parallaxProgress: { [zone: string]: any } = {};

		for (var zoneName in this.order) {
			range = this.xCache[zoneName].max - this.xCache[zoneName].min;
			abs = parallaxProgress[zoneName] = progress - this.xCache[zoneName].parallaxCenter;
			rel = abs * (1 / range);

			parallaxProgress[zoneName] = {
				abs: abs,
				rel: rel
			};
		}

		return parallaxProgress;
	}
};
